var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.hidden,
          expression: "!hidden"
        }
      ],
      class: [_vm.prefixCls + "-wrap"]
    },
    [
      _c("div", { class: [_vm.prefixCls + "-title"] }, [
        _vm._v(_vm._s(_vm.label))
      ]),
      _vm._v(" "),
      _c("ul", [
        _c(
          "li",
          { ref: "options", class: [_vm.prefixCls] },
          [_vm._t("default")],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }